import { Component, OnInit, OnDestroy, ViewChild, Input, Output, EventEmitter, NgZone } from '@angular/core';
import { IonContent } from '@ionic/angular';  // renamed from Content
//import { TranslateService } from '@ngx-translate/core';

import { ApiReturn } from 'src/app/services/api/apireturn';
import { GlobalService } from 'src/app/services/global/global.service';

// https://stackoverflow.com/questions/47584359/angular-error-component-x-is-not-included-in-a-module-when-declared-in-a
@Component({
  selector: 'myapiinfo',
  templateUrl: './myapiinfo.component.html',
  styleUrls: ['./myapiinfo.component.scss'],
})
export class MyapiinfoComponent implements OnInit, OnDestroy {

  @ViewChild(IonContent) content: IonContent;    

  //@Input('pageName') pageName:string;
  @Input() pageName:string; //@Input('pageName') pageName;
  @Output() outIsPageReady: EventEmitter<boolean> = new EventEmitter<boolean>();
  
  consoleLog:boolean = false;
  public apiReturn:ApiReturn = new ApiReturn();

  // specific page information (technical identifier stuff)
  EventId:number = 0;
  
  constructor( public zone: NgZone
    //, public events: Events
    , private globalProvider:GlobalService
    //, public translate:TranslateService
  ) 
  {
    this.consoleLog = this.globalProvider.consoleLog_myapiinfo;
    if (this.consoleLog) console.log('myapiinfo.ctor - LifeCycle');
  }

  // ----------------------------------------------------
  // -------- COMPONENT LIFE-CYCLE EVENTS  --------------
  // ----------------------------------------------------

  ngOnInit() 
  {
    if (this.consoleLog) console.log('myapiinfo.ngOnInit - ' + this.pageName + ' - LifeCycle');
  }

  // this IS called -- just before the component is removed
  ngOnDestroy() 
  { 
    if (this.consoleLog) console.log('myapiinfo.ngOnDestroy - ' + this.pageName + ' - LifeCycle');
  }

  // ----------------------------------------------------
  // ----------------  COMPONENT LOGIC  -----------------
  // ----------------------------------------------------

  SetApiReturn(apiReturn:any)
  {
    if (!apiReturn) 
    { 
      console.warn("myapiinfo.SetApiReturn: missing apiReturn - " + this.pageName, apiReturn);
      return; 
    }
    this.zone.run(() => 
    {
      if (this.consoleLog) console.log("myapiinfo.SetApiReturn - " + this.pageName, apiReturn);
      this.apiReturn.SetApiReturn(apiReturn);
    });
  }

  GetApiReturn():ApiReturn
  {
    return this.apiReturn;
  }

  ClearApiReturn()
  {
    this.apiReturn = new ApiReturn();
  }

  /*
  
  SetApiCallInfo(apiResponse:any)
  {
    if ((!apiResponse) || (!apiResponse.ApiReturn)) { return; }
    this.zone.run(() => 
    {
      this.apiReturn.SetApiReturn(apiResponse.ApiReturn);
    });
  }
  */
}
